<template>
	<div class="withdraw-container">
		<div class="withdraw-header">
			<h4>Saque</h4>
			<i class="fas fa-times" v-on:click="closeModal" />
		</div>
		<div class="withdraw-content">
			<div class="account-container" v-if="accounts.length">
				<div class="account-user-banks">
					<div class="user-account" :key="bankAccount.id" v-for="bankAccount in accounts">
						<div class="user-account-content">
							<div>
								<p class="user-account-type">{{ bankAccount.accountType }}</p>
								<p class="user-account-title">{{ bankAccount.bankName || '' }}</p>
							</div>
							<p class="user-account-value">{{ bankAccount.value }}</p>
						</div>
					</div>
				</div>
			</div>
			<h4 class="account-title" v-if="!accounts.length">Cadastre sua conta</h4>
			<div v-if="!accounts.length" class="new-account">
				<v-layout row wrap>
					<a-text-field class="new-account-field" hide-details label="Nome completo" sm12 v-model="account.name"></a-text-field>
					<a-select-field class="new-account-field" hide-details  label="Banco" v-model="account.bankId" obj="bank"></a-select-field>
					<a-text-field class="new-account-field account" hide-details label="Conta" sm9 v-model="account.acctNo"></a-text-field>
					<a-text-field class="new-account-field" hide-details label="Dígito" sm3 v-model="account.digit" v-mask="'#'"></a-text-field>
					<a-text-field class="new-account-field" hide-details label="Agência" sm12 v-model="account.branchNo" v-mask="'####'"></a-text-field>
					<a-select-field class="new-account-field" hide-details label="Tipo de Conta" sm12 v-model="account.acctType" :suggestions="acctTypes"></a-select-field>
				</v-layout>
			</div>
			<h4 class="account-title">Valor a ser sacado</h4>
			<input class="withdraw-balance" v-money="money" v-model="withdrawBalance" />
			<div class="withdraw-details">
				<p>
					<span>Saldo disponível:</span>
					<span>{{ maxWithdraw | fmtMoney }}</span>
					<v-tooltip bottom color="#000">
						<i class="fas fa-info-circle" slot="activator" />
						<span v-if="!affiliateCompanyType">Máximo de saque mensal é de {{ maxMonthWithdraw | fmtMoney }} por CPF.</span>
						<span v-else>Transações acima de R$ 3.000,00 passarão por uma aprovação da nossa equipe.</span>
					</v-tooltip>
				</p>
				<p>
					<span>Taxa: </span>
					<span>
						{{ withdrawTax | fmtMoney }}
					</span>
					<v-tooltip bottom color="#000">
						<i class="fas fa-info-circle" slot="activator" />
						Taxa referente ao valor cobrado da transação.
					</v-tooltip>
				</p>
			</div>
			<button class="btn-withdraw" @click="withdraw">
				<v-progress-circular v-if="withdrawLoading" color="white" size="16" indeterminate="indeterminate"></v-progress-circular>
				<p>{{ withdrawLoading ? 'Efetuando...' : 'Efetuar Saque' }}</p>
			</button>
		</div>
		<div v-if="loading" class="fullscreen-loading">
            <v-progress-circular color="blue" indeterminate="indeterminate"></v-progress-circular>
        </div>

		<v-dialog max-width="600px" v-model="showCodesModal" persistent>
			<CodesModal :cooldown="cooldown" :cooldownTime="cooldownTime" :setCooldownTime="setCooldownTime" :timeToResendCodes="timeToResendCodes" :onValidateCodes="validateCodes" :onClose="closeCodesModal" :email="email" :mobileNumber="mobileNumber"/>
		</v-dialog>
	</div>
</template>
<script>
import moment from 'moment';
import ATextField from "@consigmais-team/vue-common/components/ATextField.vue";
import CodesModal from "./CodesModal.vue";

export default {
  	components: { 
		ATextField, 
		CodesModal 
	},

	props: {
		walletId: {
			type: Number,
			required: true
		},
		onClose: {
			type: Function,
			required: true
		},
		onWithdraw: {
			type: Function,
			required: true
		},
		accounts: {
			type: Array,
			required: true
		},
		withdrawMinWithTax: {
			type: Number,
			required: true
		},
		withdrawMin: {
			type: Number,
			required: true
		},
		withdrawTax: {
			type: Number,
			required: true
		},
		maxMonthWithdraw: {
			type: Number,
			required: true
		},
		affiliateCompanyType: {
			type: Number,
			required: false
		},
		maxWithdraw: {
			type: Number,
			required: true
		},
        mobileNumber: {
            type: String,
            required: true
        },
        email: {
            type: String,
            required: true
        }
	},

	watch: {
		'withdrawBalance'(newValue) {
			let value = parseInt(newValue.toString().replaceAll(/\D+/g, '')) / 100;
			if (value > this.maxWithdraw) this.withdrawBalance = this.maxWithdraw * 100;
		},

        'cooldownTime' (value) {
            if (value > 0) {
                setTimeout(() => {
                    this.cooldownTime--;
                }, 1000);
            } else {
                this.cooldown = false;
            }
        },
	},

	data() {
		return {
			codesCooldown: false,
			showCodesModal: false,

            cooldown: false,
            cooldownTime: 0,
			timeToResendCodes: 180, // SECONDS = 3 minutes

			selectedAccountIndex: 0,
			bankAccountId: null,
			withdrawBalance: 0,
			loading: false,
			withdrawLoading: false,
			money: {
				decimal: ',',
				thousands: '.',
				prefix: 'R$ ',
				suffix: '',
				precision: 2,
				masked: false
			},
			account: {
				name: null,
				bankId: null,
				acctNo: null,
				branchNo: null,
				digit: null,
				acctType: null,
			},
			acctTypes: [
				{
					id: 'C',
					name: 'Conta Corrente'
				},
				{
					id: 'P',
					name: 'Conta Poupança'
				}
			]
		}
	},

	methods: {
		closeModal() {
			this.onClose();
		},

		setCooldownTime(value) {
			this.cooldown = true;
			this.cooldownTime = value;
		},

		closeCodesModal() {
			this.showCodesModal = false;
			this.withdrawLoading = false;
		},

		async validateCodes(codes) {
			this.showCodesModal = false;

			try {
				await this.$api.dataService.execute('wallet/withdrawBalance', {
					walletId: this.walletId,
					amount: parseFloat(this.withdrawBalance.toString().replaceAll(/\D+/g, '')) / 100,
					bankAccountId: this.accounts.length ? this.accounts[0].id : null,
					account: {
						name: this.account.name,
						bankId: this.account.bankId,
						acctNo: this.account.acctNo + this.account.digit,
						branchNo: this.account.branchNo,
						acctType: this.account.acctType,
					},
					smsToken: codes.smsToken,
					emailToken: codes.emailToken
				});

				this.$notifyUser({
					type: 'success',
					message: 'Solicitação efetuada com sucesso!'
				});

				this.closeModal();
				this.onWithdraw();

				this.withdrawLoading = false;
				this.withdrawBalance = 0;

			} catch (error) {
				this.withdrawLoading = false;
			}			
		},

		async withdraw() {
			if (this.accounts.length && this.accounts[0].isBlocked) {
				this.$notifyUser({
					type: 'error',
					message: `Sua conta bancária está bloqueada. Entre em contato com o suporte para mais informação e desbloqueio.`
				});

				return;
			}
			
			if (!this.accounts.length && (!this.account.name || !this.account.bankId || !this.account.acctNo || !this.account.digit || !this.account.branchNo || !this.account.acctType)) { // Validação de preenchimento da conta
				this.$notifyUser({
					type: 'error',
					message: 'Preencha todos os campos para continuar.'
				});
			} else {
				if (parseFloat(this.withdrawBalance.toString().replaceAll(/\D+/g, '')) / 100 < this.withdrawMin) { // Validação de valor mínimo
					this.$notifyUser({
						type: 'error',
						message: 'Valor mínimo para saque é de R$ ' + this.withdrawMin
					});
				} else {
					this.withdrawLoading = true;
					if (!this.cooldown) {
						try {
							let auxToken = await this.$api.dataService.execute('token/sendVerificationToken', {});
							if(auxToken){
								this.$notifyUser({
									type: 'success',
									message: 'Tokens de validação enviado para Email.'
								});
							}

							this.setCooldownTime(this.timeToResendCodes);
							this.showCodesModal = true;
						} catch(err) {
							if (err.data) this.setCooldownTime(this.timeToResendCodes - moment.utc(moment().utc(-3)).diff(moment.utc(moment(err.data)), 'seconds'));
							this.showCodesModal = true;
						}
					} else {
						this.showCodesModal = true;
					}
				}
			}
		},
	}
}
</script>

<style scoped>
p {
	margin: 0;
}

.withdraw-container {
	width: auto;
	max-height: 550px;
	background-color: var(--background-color);
	border-radius: 10px;
	padding: 20px;
	overflow: auto;
	position: relative;
}

.withdraw-header {
	width: 100%;
	display: flex;
	justify-content: space-between;
}

.withdraw-header > i {
	font-size: 22px;
	cursor: pointer;
}

.withdraw-header > h4,
.withdraw-header > i {
	color: var(--primary-color);
	font-weight: bold;
}

.withdraw-balance {
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	background-color: var(--card-color);
	border-radius: 5px;
	padding: 10px 15px;
	font-size: 16px;
	outline: none;
	color: black;
}

.withdraw-content {
	display: flex;
	flex-direction: column;
	/* margin-top: 25px; */
	width: 100%;
	overflow: auto;
}

.btn-withdraw {
	width: auto;
	background-color: var(--secondary-color);
	padding: 7px 20px;
	border-radius: 5px;
	box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);
	cursor: pointer;
	transition: 0.2s;
	user-select: none;
	font-weight: bold;
	font-size: 16px;
	color: white;
	align-self: flex-end;
	margin-top: 15px;
	display: flex;
	flex-direction: row;
	align-items: center;
}
.btn-withdraw > .v-progress-circular {
	margin-right: 10px;
}

.max-withdraw {
	font-size: 16px;
	color: var(--black-color);
	font-weight: bold;
	margin-top: 10px;
	align-self: flex-end;
}

input {
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	background-color: var(--card-color);
	border-radius: 5px;
	padding: 10px 15px;
	font-size: 16px;
	outline: none;
	color: black;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.new-account {
	margin: 15px 0;
}

.new-account .new-account-field {
	margin-bottom: 10px;
}

.new-account-field.account {
	padding-right: 20px;
}

.withdraw-details {
	font-size: 12px;
	color: #555;
	text-align: right;
	margin-top: 5px;
	margin-right: 15px;
	display: flex;
	flex-direction: column;
	align-items: flex-end;
}

.withdraw-balance {
	text-align: right;
}


/* ACCOUNTS */

.account-title {
	font-size: 16px;
	color: var(--black-color);
	font-weight: bold;
	margin-top: 10px;
	margin-bottom: 10px;
}

.account-container {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	margin: 15px 0;
}

.account-user-banks {
	width: 100%;
	display: flex;
	flex-direction: row;
	flex: 1;
	overflow: hidden;
	scroll-snap-type: x mandatory;
	-webkit-overflow-scrolling: touch;
}

.btn-left, .btn-right {
	width: 30px;
	height: 100px;
	font-size: 20px;
	background-color: var(--card-color);
	color: var(--primary-color);
	border-radius: 5px;
	flex: none;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
}

.user-account {
	width: 100%;
	height: 100px;
	padding: 15px;
	background-color: var(--card-color);
	border-radius: 5px;
	display: flex;
	flex-direction: row;
	flex: none;
	margin-right: 15px;
	scroll-snap-align: start;
}

.user-account-content {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}

.user-account-title {
	color: var(--neutral-color);
	font-weight: bold;
}

.user-account-type {
	font-size: 20px;
	color: var(--primary-color);
	font-weight: bold;
	line-height: 1;
}

.user-account-value {
	color: var(--neutral-color);
	line-height: 1;
}

.user-account-add i {
	font-size: 20px;
}

.user-account i {
	margin-left: 15px;
}

.user-account i,
.user-account-add i {
	color: var(--primary-color);
}

.withdraw-account-type-options {
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	gap: 10px;
	margin-bottom: 15px;
}

.withdraw-account-type-option {
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	background-color: var(--card-color);
	border-radius: 5px;
	color: var(--primary-color);
	padding: 10px 8px;
	font-weight: bold;
	font-size: 14px;
}

.withdraw-account-type-option > i {
	font-size: 18px;
	margin-right: 10px;
}


.withdraw-account-type-option.selected {
	background-color: var(--primary-color);
	color: white;
}

.fullscreen-loading {
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0;
	left: 0;
	background-color: #EFEFEF;
	z-index: 2000;
	display: flex;
	justify-content: center;
	align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/components/WithdrawModal.vue